import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { getValuesForSelectedOptions } from 'commons/productUtils';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from 'components/consumer/PDP/state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';

// Standard product properties shared by the PDP Gallery + Cylindo Avo events.
// Callers pick the subset their event's schema allows - the schemas differ.
const usePDPGalleryProductProperties = () => {
  const $ = _c(16);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    data: optionData
  } = usePDPOptions();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  const isDecideLater = pdpSelectedCustomizerTab === "decide-later";
  let fabric;
  let t0;
  if ($[0] !== isDecideLater || $[1] !== optionData?.options || $[2] !== optionData?.selectedOptions) {
    const variantSelectedOptions = getValuesForSelectedOptions(optionData?.options, optionData?.selectedOptions);
    ({
      fabric
    } = variantSelectedOptions);
    t0 = isDecideLater ? "Decide Later" : Object.keys(variantSelectedOptions).map(key => variantSelectedOptions[key]?.value || null).filter(Boolean).join(", ");
    $[0] = isDecideLater;
    $[1] = optionData?.options;
    $[2] = optionData?.selectedOptions;
    $[3] = fabric;
    $[4] = t0;
  } else {
    fabric = $[3];
    t0 = $[4];
  }
  const variant = t0;
  const t1 = basicDetails?.type?.name || "";
  const t2 = basicDetails?.family?.name || "";
  const t3 = basicDetails?.name || "";
  const t4 = basicDetails?.id || 0;
  const t5 = `${basicDetails?.sku || ""}${selectedOptionsVariantSku || ""}`;
  const t6 = (priceData?.price?.final_price ?? 0) + (priceData?.optionPrice ?? 0);
  const t7 = fabric?.id || 0;
  const t8 = isDecideLater ? "Decide Later" : fabric?.value || "";
  const t9 = isDecideLater ? "Decide Later" : fabric?.color || "";
  let t10;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9 || $[14] !== variant) {
    t10 = {
      category: t1,
      productFamily: t2,
      name: t3,
      productId: t4,
      sku: t5,
      price: t6,
      variant,
      fabricId: t7,
      fabricName: t8,
      fabricColor: t9
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = variant;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default usePDPGalleryProductProperties;